import { MessageTemplateApi } from "../api"
import { ContractTemplate } from "../classes"
export class MessageTemplate {
  constructor(props) {
    for (const [key, value] of Object.entries(props)) {
      this[key] = value;
    }
  }
  static async createMessageTemplate(formData) {
    const { data } = await MessageTemplateApi.createMessageTemplate(formData);
    return new MessageTemplate(data.result)
  }
  static async removeMessageTemplate(id){
    const { data } = await MessageTemplateApi.removeMessageTemplate(id);
    return data
  }
  static async updateMessageTemplate(formData) {
    const { data } = await MessageTemplateApi.updateMessageTemplate(formData);
    return new MessageTemplate(data.result)
  }
  static async getMessageTemplateByProject(projectId){
    const { data } = await MessageTemplateApi.getMessageTemplateByProject(projectId);
    return data.result.map(item => new MessageTemplate(item));
  }
  prepareObjectData({project, market, contract, customer, billingSettings, areaAccountingProducts, contractSuspend, areaInterest}){
    this.templateObjectData = ContractTemplate.prepareObjectData({project, market, contract, customer, billingSettings, areaAccountingProducts, contractSuspend, areaInterest})
    this.contented = ContractTemplate.prepareHtmlContent(this.content, this.templateObjectData)
  }
}